<template lang="html">
  <div class="auth-form-transparent text-left p-3">
    <div class="brand-logo">
      <img src="/img/logo.png" alt="logo"> TradingApp
    </div>
    <h4>{{lang=="ru"?"Вы здесь впервые?":"Are you here for the first time?"}}</h4>
    <h6 class="font-weight-light">{{lang=="ru"?"Присоединяйтесь сегодня! Это займет всего несколько шагов":"Join us today! It takes only few steps"}}</h6>
    <h6 class="font-weight-light" style='color: red' :class='errorText ? "" : "invisible"'>{{errorText}}</h6>
    <h6 class="font-weight-light" style='color: red' :class='error_password_text ? "" : "invisible"'>{{error_password_text}}</h6>
    <form class="pt-3">
      <div class="form-group">
        <label>{{email_text}}</label>
        <div class="input-group">
          <div class="input-group-prepend bg-transparent">
            <span class="input-group-text bg-transparent border-right-0">
              <i class="fa fa-envelope text-primary"></i>
            </span>
          </div>
          <input type="email" class="form-control form-control-lg border-left-0 input-auth" v-model="email" :placeholder="email_text" v-on:keyup.enter='signup'>
        </div>
      </div>
      <div class="form-group">
        <label>{{password_text}}</label>
        <div class="input-group">
          <div class="input-group-prepend bg-transparent">
            <span class="input-group-text bg-transparent border-right-0">
              <i class="fa fa-lock text-primary"></i>
            </span>
          </div>
          <input type="password" class="form-control form-control-lg border-left-0 input-auth" v-model="password" :placeholder="password_text" v-on:keyup.enter='signup'>
        </div>
      </div>
      <div class="form-group">
        <label>{{confirm_text}}</label>
        <div class="input-group">
          <div class="input-group-prepend bg-transparent">
            <span class="input-group-text bg-transparent border-right-0">
              <i class="fa fa-lock text-primary"></i>
            </span>
          </div>
          <input type="password" class="form-control form-control-lg border-left-0 input-auth" v-model="password_confirmation" :placeholder="confirm_text" v-on:keyup.enter='signup'>
        </div>
      </div>
      <div class="text-center mt-4 font-weight-light">
        {{lang=="ru"?"Регистрируясь, вы принимаете наши":"By signing up you accept our"}} <a href='https://yadi.sk/d/gRkhESzK-NqNsQ?w=1' class="text-primary">{{lang=="ru"?"Условия и положения":"Terms and Conditions"}}</a>
      </div>
      <div class="mt-3">
        <a class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" v-on:click="signup" style="color:white">{{lang=="ru"?"Регистрация":"SIGN UP"}}</a>
      </div>
      <div class="text-center mt-4 font-weight-light">
        {{lang=="ru"?"Уже есть аккаунт?":"Already have an account?"}} <router-link to='/login' class="text-primary">{{lang=="ru"?"Войти":"Login"}}</router-link>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      password_confirmation: '',
      errorText: null,
      error_password_text:null,
      notificationModal: false,
      lang:'en',
      password_text:"Password",
      confirm_text:"Confirm password",
      email_text:"Email"
    }
  },
  created(){
    this.email=this.$route.query.email;
    this.lang = this.$cookie.get('lang');
    if(this.lang=="ru"){
      this.password_text="Пароль"
      this.confirm_text="Подтвердите пароль"
      this.email_text="Почта"
    }
  },
  methods: {
    signup () {
      this.errorText = null
      this.error_password_text = null
      this.axios.post('/sign_up', {
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation
      }, {withCredentials: true}).then((response) => {
        response = response.data
        console.log(response)
        if (response.success) {
          // this.$router.push('/check-mail')
          window.location.href="https://tradingapp.pro";
        } else {
          var email_error=response.message.email?"Email "+response.message.email[0]:"";
          var passord_error=response.message.password_confirmation?"Password doesn't match.":""
          console.log(response.message);
          this.errorText = email_error
          this.error_password_text = passord_error
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/SignupForm.vue